/** @jsx jsx */
import { Flex } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

interface CommentProps {}

export const Comment: FC<CommentProps> = ({ children }) => {
  return (
    <Flex
      backgroundColor="n25"
      borderRadius="xl"
      p="sm"
      sx={{ borderBottomLeftRadius: 0 }}
      gap="xs"
      flexDirection="column">
      {children}
    </Flex>
  );
};
